export const timingFunc = {
	easeInCubic: 'cubic-bezier(0.32, 0, 0.67, 0)',
	easeOutCubic: 'cubic-bezier(0.33, 1, 0.68, 1)',
	easeOutSine: 'cubic-bezier(0.61, 1, 0.88, 1)',
}
